import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Navigate, Route, Routes } from 'react-router-dom';
import Layout from './Layout';
import { Assets, AssetsDetail, Dashboard, Incidents, Settings, Systems, LiveFeed } from '@ui/pages';
import Projects from '@ui/pages/Projects';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { resetFilters } from '@application/redux/dashboard/dashboard-slice';
import { resetPagination as resetAssetSpecificPagination } from '@application/redux/asset-specific-incidents/asset-incidents-slice';
import { MapView } from '@ui/pages/map-view';
import { RequireAuth } from '../../application/redux/auth/requireAuth';
const AppRoutes = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    useEffect(() => {
        // Reset dashboard filters when navigating TO dashboard
        if (location.pathname === '/dashboard') {
            dispatch(resetFilters());
        }
        // Reset asset-specific incidents pagination when navigating to asset detail
        if (location.pathname.startsWith('/detail-asset/')) {
            dispatch(resetAssetSpecificPagination());
        }
        // Note: Incident page state is now reset in the component's unmount cleanup
        // This provides proper isolation and doesn't rely on route detection
    }, [location.pathname, dispatch]);
    return (_jsxs(Routes, { children: [_jsx(Route, { path: '/', element: _jsx(Navigate, { to: '/dashboard' }) }), _jsxs(Route, { element: _jsx(RequireAuth, { children: _jsx(Layout, {}) }), children: [_jsx(Route, { path: '/dashboard', element: _jsx(Dashboard, {}) }), _jsx(Route, { path: '/settings', element: _jsx(Settings, {}) }), _jsx(Route, { path: '/map-view', element: _jsx(MapView, {}) }), _jsx(Route, { path: '/live-systems', element: _jsx(Systems, {}) }), _jsx(Route, { path: '/detail-asset/:asset', element: _jsx(AssetsDetail, {}) }), _jsx(Route, { path: '/detail-asset/:assetId/live-feed/:systemId', element: _jsx(LiveFeed, {}) }), _jsx(Route, { path: '/detail-asset', element: _jsx(Assets, {}) }), _jsx(Route, { path: '/incidents', element: _jsx(Incidents, {}) }), _jsx(Route, { path: '/incidents/:id', element: _jsx(Incidents, {}) }), _jsx(Route, { path: '/projects', element: _jsx(Projects, {}) }), _jsx(Route, { path: '*', element: _jsx(Dashboard, {}) })] })] }));
};
export default AppRoutes;
